var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "ig--submit_entry",
      style: { "background-color": _vm.mColor(14) },
      attrs: { href: "javascript:;" },
      on: { click: _vm.toSubmit }
    },
    [
      _c("sui-icon", {
        staticClass: "submit_icon",
        attrs: { fill: _vm.mColor(16), name: "edit" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }